import React from "react";
import ComingSoon from "../common/ComingSoon";

function SkillsAndRoles({ theme }) {
  return <ComingSoon theme={theme} />;
}

export default SkillsAndRoles;
